import { splitEvery } from 'ramda';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

// TopRightMenu new Props - HTML/Mode

@Component({
  name: 'GridTab'
})
export default class GridTab extends Vue {
  @Prop({ default: "" }) title;
  @Prop({ default: "" }) id;
  @Prop({ default: true }) showTabTitle;

  get finalTitle() {
    if (this.title) {
      return this.title;
    } else if (this.id) {
      return this.$t(this.id);
      // return this.id;
    }
  }

  mounted() {
    // console.log({ "m ounted": this.$slots.default });

    // console.log({ 'ela': this.$el, columns, columnsJSX: this.columnsJSX });

    // this.$el.replaceChildren(columnsJSX);
  };

  get columnSlots() {
    console.log({ "this.$slots.default": this.$slots.default });
    this.$slots.default?.map(e => console.log('e.componentInstance', e?.data));
    return this.$slots.default?.filter(e => e?.data && !e?.componentOptions?.propsData?.span);
  }


  render(h) {
    return (
      <div class="dt-grid-tab" id={this.id}>
        {(this.finalTitle && this.showTabTitle) ? <div class="dt-grid-tab--title">
          {this.finalTitle}
        </div> : undefined}
        <div class="dt-grid-tab--header">
          {this.$slots.header}
        </div>
        <div class="dt-grid-tab--body">
          {this.$slots.default}
        </div>
      </div>
    );
  }
  // render(h) {
  //   return (
  //     <div class="dt-grid-tab">
  //       {splitEvery(this.columnSlots.length / 3, this.columnSlots).map(e => <div class="dt-grid-column">
  //         {e}
  //       </div>)}
  //     </div>
  //   );
  // }
}
